import React from 'react'
import { useTranslation } from 'react-i18next'
import { BeWizrLinkItem } from '~/models'
import { memo } from '~/ui/component'
import { TextBlock } from '~/ui/components'
import BeWizrTile from '../../bewizr/BeWizrTile'
import { register } from './registry'

export interface Props {
  item: BeWizrLinkItem
}

const BeWizrLinkLibraryItem = memo('BeWizrLinkLibraryItem', (props: Props) => {

  const {item} = props

  const [t] = useTranslation('bewizr-misc-items')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrTile
        label={t('bewizr-library:item-types.linkitem')}
        title={item.title}
        icon='link'
        href={`/bewizr-misc-items/link/-/${item.id}`}
        image={item.links.image ?? item.openGraphJson?.image ?? null}
        buttonCaption={t('link.view')}
        horizontal
      >
        {item.shortDescription != null && (
          <TextBlock dim small>
            {item.shortDescription}
          </TextBlock>
        )}
      </BeWizrTile>
    )
  }

  return render()

})

register('linkitem', BeWizrLinkLibraryItem)